// Ajustes de tipografia da home pedidos por UM cliente (código compartilhado dos ~300 sites):
// título do hero em duas linhas, subtítulo maior, texto dos cards (modelo_card 5) maior e preto,
// "Quem somos" com fundo marfim e fonte maior, "Pesquisas mais populares" com fonte maior.
// Gate por codsite: fora da lista nada muda.
const CODSITES_FONTES_MAIORES = new Set<number>([
    2637, // Castro Patrimônio (Daniel, 23/09)
]);

export const fontesMaioresDoSite = (site: any): boolean =>
    CODSITES_FONTES_MAIORES.has(Number(site?.id));

// Fundo da seção "Quem somos" dos sites acima (marfim no lugar do branco).
export const COR_MARFIM = '#f6f1e7';

// "Seu patrimônio. Nossa estratégia." → segunda frase na linha de baixo (só a 1ª quebra).
export const tituloEmDuasLinhas = (html: string): string =>
    String(html ?? '').replace(/([.!?])\s+(?=\S)/, '$1<br/>');
